export enum DisplayFormat {
  Data = 'Data view',
  Graph = 'Graph view',
  Condensed = 'Condensed view',
  Group = 'Grouped view',
}
